import { buildLogicContext } from '../../../surveyLogic/context/buildLogicContext';
import { getVisibleQuestions } from '../../../surveyLogic/visibility';
import type { SurveyPaginationContext } from '../../types';
import type { OnNextRunState, OnNextSubmit } from './types';

type BuildOnNextRunStateParams = {
  context: SurveyPaginationContext;
  onSubmit: OnNextSubmit;
  currentPageIndex: number;
  rawCurrentQuestions: SurveyPaginationContext['pages'][number]['questions'];
};

export function buildOnNextRunState({
  context,
  onSubmit,
  currentPageIndex,
  rawCurrentQuestions,
}: BuildOnNextRunStateParams): OnNextRunState | null {
  const { survey, pages, values, paginationRefs, customFieldValues } = context;
  const currentPage = pages[currentPageIndex];
  const refs = paginationRefs.current;

  if (!survey || !currentPage || !refs) {
    return null;
  }

  refs.visitedPageIndices.add(currentPageIndex);

  const allQuestions = survey.pages.flatMap(page => page.questions);
  const logicContext = buildLogicContext(values, allQuestions, customFieldValues);
  const currentQuestions = getVisibleQuestions(rawCurrentQuestions, logicContext);

  return {
    survey,
    pages,
    currentPage,
    currentPageIndex,
    values,
    allQuestions,
    logicContext,
    currentQuestions,
    refs,
    setValues: context.setValues,
    setCurrentPageIndex: context.setCurrentPageIndex,
    setPhase: context.setPhase,
    setValidationErrors: context.setValidationErrors,
    trackPageTime: context.trackPageTime,
    trackOptionalSkips: context.trackOptionalSkips,
    checkBacktrackChanges: context.checkBacktrackChanges,
    bumpProgressRevision: context.bumpProgressRevision,
    onSubmit,
  };
}
